export const createHstcScheduler = props => setInterval(() => props.callback(props.getHstc()), props.interval);